import { AxiosResponse } from 'axios'
import apiClient from './common/common'
import { AtemQuestIdExistsRequest } from './common/requests'
import { AtemQuestIdExistsResponse } from './common/responses'

/**
 * ATEMクエストID存在チェックAPI
 * @param request
 * @param callback
 */
export const aqIdExistsAPI = async (request: AtemQuestIdExistsRequest, callback: (response: AtemQuestIdExistsResponse) => void) => {
  await apiClient.post('/atemQuestId/exists', request).then((response: AxiosResponse<AtemQuestIdExistsResponse>) => {
    callback(response.data)
  })
}
